import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { maintenanceApi } from '../api';
import { getErrorMessage } from '@/api/unwrapQuery';
import { queryClient } from '@/api/queryClient';
import { queryKeys } from '@/api/queryKeys';

/**
 * Admin action hook toggling the global maintenance mode.
 * Invalidates both the public maintenance status and admin settings caches.
 */
export const useMaintenanceActions = () => {
    const mutation = useMutation({
        mutationFn: ({ enabled }) => maintenanceApi.setStatus(enabled),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.maintenance.status });
            queryClient.invalidateQueries({ queryKey: queryKeys.adminSettings });
        },
    });

    const setMaintenance = useCallback(
        async (enabled) => {
            try {
                await mutation.mutateAsync({ enabled });
                return { success: true };
            } catch (err) {
                return { success: false, error: getErrorMessage(err, 'خطا در تغییر وضعیت تعمیرات') };
            }
        },
        [mutation],
    );

    return {
        setMaintenance,
        loading: mutation.isPending,
        error: getErrorMessage(mutation.error, 'خطا در تغییر وضعیت تعمیرات'),
    };
};

export default useMaintenanceActions;
